$(() => {
  const duration = 300;
  const pricingTableSection = $('.pricing-table');
  const showAllFeatures = pricingTableSection.find('.js-show-all-features .ct-text-block');
  const pricingTableSubRowWrapper = pricingTableSection.find('.pricing-table-sub-row-wrapper');
  const pricingTableHeader = pricingTableSection.find('.pricing-table-header');

  if (pricingTableSection.length == 0) {
    return;
  }
  
  showAllFeatures.on('click', (e) => {
    const adminBarHeight = $('#wpadminbar').length > 0 ? $('#wpadminbar').height() : 0;
    const headerHeight = $('header').height() + adminBarHeight;
    $('html, body').animate({
      scrollTop: $(e.currentTarget).parents('.pricing-table-wrapper').offset().top - headerHeight
    }, 300);

    const isExpanded = pricingTableHeader.hasClass('table-expanded');
    if (isExpanded) {
      pricingTableHeader.removeClass('table-expanded');
      pricingTableSubRowWrapper.slideUp(duration);
      showAllFeatures.text('Show all features');
    } else {
      pricingTableHeader.addClass('table-expanded');
      pricingTableSubRowWrapper.slideDown(duration);
      showAllFeatures.text('Summarize features');
    }
  });
});
